import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdfScannerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"adf_scanner"}/>
}
